"use client"

import { iconsMap } from "@/public/icons/iconsMap"
import { colors } from "@/ui/theme/colors"
import styled from "@emotion/styled"
import {
  MenuItem,
  MenuProps,
  Select,
  SelectChangeEvent,
  SelectProps,
} from "@mui/material"
import { ReactNode } from "react"

export const StyledSelect = styled(Select)`
  & .MuiSelect-select {
    text-align: left;
    padding-inline-start: 0;
  }
  & > .MuiFilledInput-input {
    font-size: 16px;
  }
  border-radius: 4px;
  height: 45px;
  align-items: center;

  // Center the custom icon vertically
  & .MuiSelect-icon {
    top: unset;
    transform: none;
    position: absolute;
    display: flex;
    align-items: center;
    pointer-events: none;
  }
`

// Styled Paper for the Select menu
import Paper from "@mui/material/Paper"

export const StyledMenuPaper = styled(Paper)`
  color: ${colors.black};
  direction: rtl;

  & ul {
    display: flex;
    flex-direction: column;
  }

  & .MuiMenu-list {
    padding: 0;
    & .MuiMenuItem-root {
      direction: ltr;
      color: ${colors.black};
    }
  }

  & .MuiMenuItem-root:hover {
    background-color: ${colors.red};
    color: ${colors.white};
  }

  &.MuiPaper-root {
    padding: 0px;
    border-radius: 12px;
    border: 1px solid ${colors.lightGray};
    max-height: 200px;
    box-shadow: -4px 8px 30px 0px rgba(2, 1, 64, 0.12);
  }
`

export const selectMenuProps: Partial<MenuProps> = {
  PaperProps: {
    component: StyledMenuPaper,
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  } as const,
  transformOrigin: {
    vertical: "top",
    horizontal: "right",
  } as const,
}

export interface SelectOption {
  id: string | number
  name: string | ReactNode
  [key: string]: any
}

export interface SelectComponentProps extends Omit<SelectProps, "onChange"> {
  options: SelectOption[]
  value: number | null
  onChange: (value: number) => void
  valueKey?: string
  labelKey?: string
}

const ChevronDownIcon = iconsMap["ChevronDownIcon"]

const SelectComponent = ({
  options,
  value,
  onChange,
  valueKey = "id",
  labelKey = "name",
  ...props
}: SelectComponentProps) => {
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    onChange(event.target.value as number)
  }

  return (
    <StyledSelect
      value={value || ""}
      onChange={handleChange}
      MenuProps={selectMenuProps}
      IconComponent={ChevronDownIcon}
      {...props}
    >
      {options &&
        options.map((option) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {option[labelKey]}
          </MenuItem>
        ))}
    </StyledSelect>
  )
}

export default SelectComponent
